import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { catchError, exhaustMap, Observable, throwError } from 'rxjs';
import { Store } from '@ngrx/store';
import { Actions, ofType } from '@ngrx/effects';

import { AuthorizationActions, AuthorizationApiActions } from '@modules/authorization/store/auth';
import { Error } from '@models';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private store: Store, private readonly actions$: Actions) {}

  intercept(req: HttpRequest<object>, next: HttpHandler): Observable<HttpEvent<object>> {
    return next.handle(req).pipe(
      catchError((response: HttpErrorResponse) => {
        // todo: verify all case of error

        // if 401 Unauthorized refresh token
        if (response && response.status === 401) {
          return this.unauthorizedHandler(req, next);
        }

        // set to error object status code
        return throwError((): Error => {
          return {
            status: response.status,
            ...response.error,
          };
        });
      })
    );
  }

  unauthorizedHandler(req: HttpRequest<object>, next: HttpHandler) {
    this.store.dispatch(AuthorizationActions.refreshAuthToken());

    return this.actions$.pipe(
      ofType(AuthorizationApiActions.refreshAuthTokenSuccess),
      exhaustMap(() => next.handle(req))
    );
  }
}
